import Nav from '../../Global/Nav.vue'
export default {
  name: 'MessageBoard',
  components: {
    Nav
  },
  data() {
    return {
      activeTab: 'products',
      vLoading: false,
      suppliersKeywords: '',
      suppliersList: [],
      suppliersTotal: 0,
      suppliersPage: 1,
      suppliersSize: 10,
      addSupplierVisible: false,
      addSupplierLoading: false,
      addSupplierForm: {
        supplier_name: null,
        contactor: null,
        phone: null,
        email: null,
        other_contacts: null,
        main_products: null,
        address: null
      },
      addSupplierRules: {
        supplier_name: [
          { required: true, message: '名称不能为空', trigger: 'commit' }
        ]
      },
      editSupplierTitle: '',
      editSupplierVisible: false,
      editSupplierLoading: false,
      editSupplierForm: {},
      editSupplierRules: {
        supplier_name: [
          { required: true, message: '名称不能为空', trigger: 'commit' }
        ]
      },
      productsKeywords: '',
      productsList: [],
      productsTotal: 0,
      productsPage: 1,
      productsSize: 10,
      addProductVisible: false,
      addProductLoading: false,
      addProductForm: {
        product_name: null,
        cas: null,
        price: null,
        factory: null,
        contactor: null,
        contactor_ways: null,
        quotation_format: `Hi xxx
Good day! Pls check us best price as below:
Product: xx
Package: In xx kg/bag,
Quantity: 1FCL,(xxMT per 20'FCL)
Price:
USDxx/MT FOB xx port, based on payment terms of xxx
Delivery: In xx ,2024
Validity of this offer: 3days`,
        status: 'A',
        memo: ''
      },
      addProductRules: {
        product_name: [
          { required: true, message: '名称不能为空', trigger: 'commit' }
        ]
      },
      editProductTitle: '',
      editProductVisible: false,
      editProductLoading: false,
      editProductForm: {},
      editProductRules: {
        product_name: [
          { required: true, message: '名称不能为空', trigger: 'commit' }
        ]
      },
      productStatus: []
    }
  },
  mounted() {
    this.init();
    this.queryProductsList();
  },
  methods: {
    async init() {
      await this.$axios.get(`/basic/products/options`).then((response) => {
        this.productStatus = response.data.data
      });
    },
    productTabClick(tab) {
      switch (tab.name) {
        case 'products':
          this.queryProductsList();
          break;
        case 'suppliers':
          this.querySuppliersList();
          break;
      }
    },
    querySuppliersList() {
      let current_page = this.suppliersPage;
      let keywords = this.suppliersKeywords;
      let size = this.suppliersSize;
      this.$axios.get('/basic/suppliers/list', {
        params: {
          keywords: keywords,
          page: current_page,
          size: size
        }
      }).then((response) => {
        if (response.data.code === 200) {
          this.suppliersList = response.data.data.data;
          this.suppliersTotal = response.data.data.total;
        }
      })
    },
    changeSuppliersSize(val) {
      this.suppliersSize = val;
      this.querySuppliersList();
    },
    currentSuppliersChange(val) {
      this.suppliersPage = val;
      this.querySuppliersList();
    },
    addSupplier() {
      this.addSupplierVisible = true;
    },
    confirmAddSupplier() {
      this.$refs.addSupplierForm.validate(valid => {
        if (valid) {
          this.addSupplierLoading = true;
          this.$axios.post('/basic/suppliers/save',
            this.addSupplierForm
          ).then(() => {
            this.querySuppliersList();
            this.addSupplierVisible = false;
            this.addSupplierLoading = false;
          })
          this.addSupplierForm = {
            supplier_name: null,
            contactor: null,
            phone: null,
            email: null,
            other_contacts: null,
            main_products: null,
            address: null
          }
        }
      })
    },
    cancelAddSupplier() {
      this.addSupplierVisible = false;
      this.addSupplierForm = {
        supplier_name: null,
        contactor: null,
        phone: null,
        email: null,
        other_contacts: null,
        main_products: null,
        address: null
      }
    },
    editSupplier(row) {
      this.editSupplierTitle = row.supplier_name;
      this.editSupplierVisible = true;
      this.editSupplierForm = row;
    },
    confirmEditSupplier() {
      this.$refs.editSupplierForm.validate(valid => {
        if (valid) {
          this.editSupplierLoading = true;
          this.$axios.post('/basic/suppliers/save',
            this.editSupplierForm
          ).then(() => {
            this.querySuppliersList();
            this.editSupplierVisible = false;
            this.editSupplierLoading = false;
          })
          this.editSupplierForm = {
            supplier_name: null,
            contactor: null,
            phone: null,
            email: null,
            other_contacts: null,
            main_products: null,
            address: null
          }
        }
      })
    },
    toggleSupplierInCooperation(row) {
      this.$axios.post('basic/suppliers/toggle_cooperation', {
        id: row.id,
        in_cooperation: row.in_cooperation
      }).then((response) => {
        if (response.data.code === 200) {
          // this.getEmailAccountsOptions();
        } else {
          row.in_cooperation = !row.in_cooperation
          this.$notify({
            title: 'failed',
            message: response.data.data,
            type: 'error'
          })
        }
      })
    },
    queryProductsList(search = false) {
      this.vLoading = true;
      let current_page = search === true ? 1 : this.productsPage;
      let keywords = this.productsKeywords;
      let size = this.productsSize;
      this.$axios.get('/basic/products/list', {
        params: {
          keywords: keywords,
          page: current_page,
          size: size
        }
      }).then((response) => {
        this.vLoading = false;
        if (response.data.code === 200) {
          this.productsList = response.data.data.data;
          this.productsTotal = response.data.data.total;
        }
      })
    },
    changeProductsSize(val) {
      this.productsSize = val;
      this.queryProductsList();
    },
    currentProductsChange(val) {
      this.productsPage = val;
      this.queryProductsList();
    },
    addProduct() {
      this.addProductVisible = true;
      this.$axios.get(`/basic/suppliers/selection`).then((response) => {
        this.suppliersList = response.data.data
      })
    },
    confirmAddProduct() {
      this.$refs.addProductForm.validate(valid => {
        if (valid) {
          this.addProductLoading = true;
          this.$axios.post('/basic/products/save',
            this.addProductForm
          ).then(() => {
            this.queryProductsList();
            this.addProductVisible = false;
            this.addProductLoading = false;
          })
          this.addProductForm = {
            product_name: null,
            cas: null,
            price: null,
            factory: null,
            contactor: null,
            contactor_ways: null,
            quotation_format: `Hi xxx
Good day! Pls check us best price as below:
Product: xx
Package: In xx kg/bag,
Quantity: 1FCL,(xxMT per 20'FCL)
Price:
USDxx/MT FOB xx port, based on payment terms of xxx
Delivery: In xx ,2024
Validity of this offer: 3days`,
            status: 'A'
          }
        }
      })
    },
    cancelAddProduct() {
      this.addProductVisible = false;
      this.addProductForm = {
        product_name: null,
        cas: null,
        price: null,
        factory: null,
        contactor: null,
        contactor_ways: null,
        quotation_format: `Hi xxx
Good day! Pls check us best price as below:
Product: xx
Package: In xx kg/bag,
Quantity: 1FCL,(xxMT per 20'FCL)
Price:
USDxx/MT FOB xx port, based on payment terms of xxx
Delivery: In xx ,2024
Validity of this offer: 3days`,
        status: 'A'
      }
    },
    editProduct(row) {
      this.editProductTitle = row.product_name;
      this.editProductVisible = true;
      this.$axios.get(`/basic/suppliers/selection`).then((response) => {
        this.suppliersList = response.data.data
      })
      this.$axios.get(`/basic/products/detail?id=${row.id}`).then((response) => {
        this.editProductForm = response.data.data;
      })
    },
    confirmEditProduct() {
      this.$refs.editProductForm.validate(valid => {
        if (valid) {
          this.editProductLoading = true;
          this.$axios.post('/basic/products/save',
            this.editProductForm
          ).then(() => {
            this.queryProductsList();
            this.editProductVisible = false;
            this.editProductLoading = false;
          })
          this.editProductForm = {
          }
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Modules/Products/script.js